/// <amd-module name="VSS/Redux/Modules/TTIMonitor/TTIMonitorSelector" />
import { ITTIMonitorState, ITTIAwareState } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorContracts";

export function isPageInteractive(state: ITTIAwareState): boolean {
    const ttiMonitorState: ITTIMonitorState = state.ttiMonitorState;
    return ttiMonitorState && ttiMonitorState.isPageInteractive;
}
